import React from 'react';
import { useTranslation } from 'react-i18next';
import { Tooltip } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import { Form, ProjectsConstructorForm } from '@/components';
import { useSchemaEpic, FormValueType } from './hooks';
import { AddEpicDto, ProjectDto } from '@/core';
import classes from './EpicForm.module.scss';

type PropsType = {
  initialValue: FormValueType;
  formUid: string;
  handleCancel?: () => void;
  handleSubmit: (epicData: AddEpicDto) => void;
  isCancelButton?: boolean;
  isTooltip?: boolean;
  projectData: ProjectDto;
};

export const EpicForm = ({
  initialValue,
  formUid,
  handleCancel,
  handleSubmit,
  isCancelButton,
  isTooltip = false,
  projectData,
}: PropsType) => {
  const { t } = useTranslation(undefined, { keyPrefix: 'projects.constructor' });
  const schemaEpic = useSchemaEpic(projectData, initialValue);

  return (
    <ProjectsConstructorForm<FormValueType>
      handleCancel={handleCancel}
      handleSubmit={handleSubmit}
      schema={schemaEpic}
      initialValues={initialValue}
      formUid={formUid}
      isCancelButton={isCancelButton}
    >
      <div className={classes.nameInput}>
        <Form.Input
          label={false}
          name="name"
          allowClear
          required
          placeholder={t('addEpics.placeholder.name')}
          suffix={
            isTooltip && (
              <Tooltip title={t('addEpics.epic.tooltip')}>
                <InfoCircleOutlined className={classes.nameInputTooltipIcon} />
              </Tooltip>
            )
          }
        />
      </div>
      <div className={classes.descriptionInput}>
        <Form.TextArea
          placeholder={t('addEpics.placeholder.description')}
          name="description"
          autoSize
          allowClear
          label={false}
        />
      </div>
    </ProjectsConstructorForm>
  );
};
